<template>
    <div class="search-condition-date-range" :value="value">
        <label for="create-time-from">{{fromText}}</label>
        <input type="text"
               id="create-time-from"
               name="create-time-from"
               :value="value.from" v-on:change="startDateChange"
               placeholder="请选择开始时间" data-date-format="yyyy/mm/dd HH:mm"
               onfocus="(this.type='datetime-local')"
               >
        <label for="create-time-to">{{toText}}</label>
        <input type="text"
               id="create-time-to"
               name="create-time-to"
               :value="value.to" v-on:change="endDateChange"
               placeholder="请选择结束时间" data-date-format="yyyy/mm/dd HH:mm"
               onfocus="(this.type='datetime-local')"
               >
    </div>
</template>

<script>
    export default {
        name: "BInputTimeRange",
        props: {
            fromText: String,
            toText: String,
            value: Object,
        },
        methods: {
            startDateChange(event) {
                var date = ''
                // if (String(event.target.value).indexOf('T')) {
                //     date = String(event.target.value).replace('T', ' ') + ':00'
                // }
                date = String(event.target.value)
                this.$emit("startTimeChange", date);
            },
            endDateChange(event) {
                var date = ''
                // if (String(event.target.value).indexOf('T')) {
                //     date = String(event.target.value).replace('T', ' ') + ':00'
                // }
                date = String(event.target.value)
                this.$emit("endTimeChange", date);
            }
        }
    }
</script>

<style scoped>
    .search-condition-date-range {
        display: flex;
        align-items: center;
    }

    .search-condition-date-range label:nth-of-type(1) {
        color: #333333;
        width: 60px;
        text-align: right;
        font-size: 14px;
        margin: 0 10px 0 20px;
    }

    .search-condition-date-range label:nth-of-type(2) {
        color: #333333;
        text-align: right;
        margin: 0 10px 0 10px;
    }

    .search-condition-date-range input {
        width: 220px;
        height: 42px;
        background: #FFFFFF;
        border: 1px solid #DEE2E6;
        border-radius: 5px;
        color: #666666;
        padding-left: 10px;
        padding-right: 10px;
    }

    input:focus {
        border: 1px solid #0171A3;
    }

    * {
        outline: none;
    }
</style>